module.exports = __webpack_public_path__ + "assets/153a339d901e38b97c30587ea5f156ff.mp3";